"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const xstate_1 = require("xstate");
const ManageAppointment_1 = __importDefault(require("./ManageAppointment"));
const ManageAppointmentContainer = ({ machine, logState }) => {
    const service = (0, react_1.useRef)((0, xstate_1.interpret)(machine).onTransition(logState));
    (0, react_1.useEffect)(() => {
        const currentService = service.current;
        currentService.start();
        return () => {
            currentService.stop();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (window && 'scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        return () => {
            if (window && 'scrollRestoration' in (window === null || window === void 0 ? void 0 : window.history)) {
                window.history.scrollRestoration = 'auto';
            }
        };
    }, []);
    return react_1.default.createElement(ManageAppointment_1.default, { service: service.current });
};
exports.default = ManageAppointmentContainer;
//# sourceMappingURL=ManageAppointmentContainer.js.map